import { createFileRoute } from "@tanstack/react-router";
import KapPage from "@/pages/KapPage";
export const Route = createFileRoute(
  "/ketamine-assisted-psychotherapy-coral-springs-fl",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Ketamine-Assisted Psychotherapy | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Ketamine-assisted psychotherapy in Coral Springs, FL. Combines ketamine with therapy for depression, PTSD, and trauma in a supervised clinical setting.",
        },
        {
          property: "og:title",
          content: "Ketamine-Assisted Psychotherapy | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Ketamine-assisted psychotherapy in Coral Springs, FL. Combines ketamine with therapy for depression, PTSD, and trauma in a supervised clinical setting.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/ketamine-assisted-psychotherapy-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/ketamine-assisted-psychotherapy-coral-springs-fl",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <KapPage />;
}
